import {
  emailValidator,
  phoneNumberValidator,
} from '../components/Forms/validators'

export const CustomUserForm = {
  model: 'CustomUser',
  format: [
    {
      widths: 'equal',
      fields: {
        first_name: {
          type: 'text',
        },
        last_name: {
          type: 'text',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        email: {
          disabled: true,
          type: 'text',
          validator: (input) => {
            return emailValidator(input)
          },
        },
        phone: {
          type: 'phone',
          validator: (input) => {
            return phoneNumberValidator(input)
          },
        },
        type: {
          type: 'text',
          label: 'Position',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        receive_sms_messages: {
          type: 'checkbox',
          label: 'Receive SMS Messages',
        },
      },
    },
  ],
}
